import clsx from 'clsx'
import { ButtonHTMLAttributes } from 'react'
import { memo } from 'react'

import { ButtonTheme, ButtonVariant } from '@/ts/Button'

import Spinner from '../Spinner'
import COLORS from './data/colors'

function Button(props: ButtonProps) {
  const {
    children,
    className,
    spinnerClassName,
    isLoading = false,
    variant = 'flat',
    theme = 'violet',
    ...rest
  } = props

  const colors = COLORS[variant][theme]

  return (
    <button
      {...rest}
      className={clsx(
        'transition-colors duration-300 outline-none focus:outline-none',
        colors,
        className,
        {
          'rounded-3xl': variant.includes('rounded'),
          'border-2': variant === 'rounded_outline',
          '!bg-sbtgray-200/60 !text-sbtgray-300 !cursor-not-allowed':
            rest.disabled && !isLoading,
        }
      )}
    >
      {isLoading ? (
        <Spinner className={clsx('mx-auto', spinnerClassName)} />
      ) : (
        children
      )}
    </button>
  )
}

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  theme?: ButtonTheme
  variant?: ButtonVariant
  isLoading?: boolean
  spinnerClassName?: string
  pbl_value?: string
}

export default memo(Button)
